import React from "react";
 
const TermsOfService = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Terms of Service</h1>
      <p><strong>Last Updated:</strong> December 04, 2024</p>
      <p>
        This agreement (the "Agreement") is entered into by and between you ("you") and Niramaya Homeopathy Clinic and Research Centre
        ("Niramaya Homeopathy," "Company," "We," "Our," or "Us") regarding your use of the web portal https://www.niramayahomoeopathy.com/
        ("Niramaya Homeopathy Website") and related services (the "Service"). By accessing or using the Service, you agree to be bound by
        these terms and conditions. If you do not agree with these terms, please do not use the Service.
      </p>
 
      <h2>Priority</h2>
      <p>
        This Agreement, in combination with Niramaya Homeopathy’s Privacy Policy (available at https://www.niramayahomoeopathy.com/privacy-policy),
        governs your use of the Service. In case of inconsistency between this Agreement and the Privacy Policy, this Agreement shall prevail.
      </p>
 
      <h2>Proper Use</h2>
      <p>
        By using the Service, you agree to comply with all applicable local, state, national, and international laws, rules, and regulations.
        You also agree not to engage in any of the following prohibited activities:
      </p>
      <ul>
        <li>Forging headers or manipulating identifiers to disguise the origin of any transmitted content.</li>
        <li>Using, displaying, mirroring, or framing the Niramaya Homeopathy Website or any of its components without prior written consent.</li>
        <li>Removing any copyright, trademark, or proprietary notices from the Website.</li>
        <li>Infringing upon Niramaya Homeopathy’s intellectual property rights, including using its logos or trademarks without permission.</li>
        <li>Uploading or transmitting content containing software viruses or any other computer code designed to interrupt, destroy, or limit the functionality of any software or hardware.</li>
        <li>Posting or sharing content that is unlawful, defamatory, abusive, fraudulent, misleading, or objectionable.</li>
        <li>Engaging in activities that disrupt the operation of the Service, such as spamming, overloading servers, or distributing malware.</li>
        <li>Harvesting or collecting personal information of other users.</li>
      </ul>
 
      <h2>Confidentiality and Use of Information</h2>
      <p>
        Niramaya Homeopathy reserves the right to use, reproduce, edit, and display the questions, comments, or feedback submitted by you
        for internal purposes or promotional content without compensation. However, such content will be used in an anonymized manner unless
        you explicitly include personally identifiable information in your submissions.
      </p>
 
      <h2>Payment Terms</h2>
      <p>
        For any paid consultation or services offered by Niramaya Homeopathy:
      </p>
      <ul>
        <li>Payment must be made in advance as per the fees specified on the Website.</li>
        <li>Fees are non-refundable unless otherwise explicitly stated in our refund policy.</li>
        <li>You are responsible for paying any applicable taxes or government-imposed fees.</li>
      </ul>
 
      <h2>Refund Policy</h2>
      <p>
        Refunds, if applicable, must be requested within the time frame specified on the Website. All refund requests should be submitted
        to Niramaya Homeopathy via the contact details provided. Reasonable requests for refunds will be reviewed and processed at our sole discretion.
      </p>
 
      <h2>Termination and Modification</h2>
      <p>
        Niramaya Homeopathy reserves the right to modify, suspend, or discontinue the Service (or any part thereof) at any time, with or without notice.
        Grounds for termination include, but are not limited to:
      </p>
      <ul>
        <li>Violations of this Agreement or applicable laws.</li>
        <li>Requests by law enforcement or government agencies.</li>
        <li>Prolonged periods of inactivity.</li>
        <li>Engagement in fraudulent, abusive, or unlawful activities.</li>
      </ul>
      <p>
        Upon termination, your right to access the Service will cease immediately.
      </p>
 
      <h2>Disclaimer of Warranties</h2>
      <p>
        The Service and its content are provided on an "AS IS" and "AS AVAILABLE" basis. Niramaya Homeopathy disclaims all warranties, express or implied,
        including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not guarantee that the Service
        will meet your requirements or be free from errors or interruptions.
      </p>
 
      <h2>Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law:
      </p>
      <ul>
        <li>Niramaya Homeopathy shall not be liable for any indirect, incidental, or consequential damages resulting from the use of the Service.</li>
        <li>Our total liability under this Agreement shall not exceed the amount paid by you for the Service in the 12 months preceding the claim.</li>
      </ul>
 
      <h2>Indemnity</h2>
      <p>
        You agree to indemnify and hold harmless Niramaya Homeopathy, its employees, and affiliates from any claims, damages, losses, or expenses
        (including attorneys' fees) arising out of your use of the Service or your violation of this Agreement.
      </p>
 
      <h2>Arbitration</h2>
      <p>
        Any disputes arising from or related to this Agreement shall be settled through binding arbitration under Indian commercial arbitration rules.
        Arbitration will take place in Gorakhpur, India, and the arbitrator’s decision will be final.
      </p>
      <p>
        Notwithstanding the above, Niramaya Homeopathy may seek injunctive relief in courts of competent jurisdiction to prevent misuse of its intellectual property or other proprietary rights.
      </p>
 
      <h2>Miscellaneous</h2>
      <ul>
        <li><strong>Severability:</strong> If any provision of this Agreement is deemed invalid or unenforceable, the remaining provisions will remain in effect.</li>
        <li><strong>Waiver:</strong> Failure to enforce any right or provision of this Agreement does not constitute a waiver of such right or provision.</li>
        <li><strong>Entire Agreement:</strong> This Agreement, along with the Privacy Policy, constitutes the entire agreement between you and Niramaya Homeopathy regarding the use of the Service.</li>
      </ul>
 
      <h2>Contact Information</h2>
      <p>If you have any questions regarding this Agreement, please contact us at:</p>
      <ul>
        <li><strong>Email:</strong> niramayaforyou@gmail.com</li>
        <li><strong>Phone:</strong> +919236185711</li>
        <li><strong>Address:</strong> 0230-B Civil Lines 2, Near DIG Bungalow, Bilandpur, Gorakhpur</li>
        <li><strong>Website:</strong> <a href="https://www.niramayahomoeopathy.com/">https://www.niramayahomoeopathy.com/</a></li>
      </ul>
    </div>
  );
};
 
export default TermsOfService;